import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";
export const getExams = (state) => state.exams;
export const getStudentsByCourse = (state) => state.studentsByCourse;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getExams,
    getStudentsByCourse,
};
